// extracted by mini-css-extract-plugin
export default {"wrapper":"TeamSection_wrapper__OgJw+","section":"TeamSection_section__+isOm","title":"TeamSection_title__4Okd4","label":"TeamSection_label__uL0U+"};